import bsCustomFileInput from 'bs-custom-file-input';

// Import TinyMCE
window.tinymce = require('tinymce/tinymce');
require('@tinymce/tinymce-jquery');

// A theme is also required
require('tinymce/themes/silver/theme');

require('tinymce/plugins/autolink');
require('tinymce/plugins/autoresize');
require('tinymce/plugins/searchreplace');
require('tinymce/plugins/advlist');
require('tinymce/plugins/code');
require('tinymce/plugins/link');
require('tinymce/plugins/lists');
require('tinymce/plugins/table');
require('tinymce/plugins/code');
require('tinymce/plugins/paste');

document.addEventListener("DOMContentLoaded", function(event) { 
   
    init();

    $(document).on('focusin', function(e) {
        if ($(e.target).closest(".tox-dialog").length) {
            e.stopImmediatePropagation();
        }
    });

});

export function init(){

    bsCustomFileInput.init();

    $('.x-form-input button[type="button"][name="delete_file"]').click(function(){

        let title = $(this).attr('confirm_delete_title');
        if(
            typeof(title) == 'undefined'
            || title == ''
        ){
            title = window.__('¿Estás seguro?');
        }

        let text = $(this).attr('confirm_delete_text');
        if(
            typeof(text) == 'undefined'
            || text == ''
        ){
            text = window.__('Esta acción no se puede deshacer');
        }

        let callback = $(this).attr('delete_callback');
        if(
            typeof callback != 'undefined'
            && callback != ''
            && typeof window['app.' + callback] == 'function'
        ){

            messages.confirm(title, text).then(() => {       
                alert('app.' + callback);
            });

        }

    });

    $('form.parsley').each(function(){
        $(this).removeClass('parsley');
        $(this).parsley();
    });

    $('input[type="password"]:not(.init_password)').each(function(){
        init_password_input($(this));
    }).addClass('init_password');

    $('select.select2:not(.init)').each(init_select2);
    $('textarea.tinymce:not(.init)').each(_init_tinymce);

    $('textarea.code:not(.init_code)').each(function(){
        $(this).keydown(function(e){
            if(e.key == 'Tab'){
    
                e.preventDefault();
                
                var start = this.selectionStart;
                var end = this.selectionEnd;
    
                this.value = this.value.substring(0, start) + "\t" + this.value.substring(end);
                this.selectionStart = this.selectionEnd = start + 1;
    
            }
        }).addClass('init_code');
    });

    $('button[type="submit"][form]:not(.init_submit)').each(function(){
        init_submit_form($(this));
    }).addClass('init_submit');

    $('input[type="text"].slug:not(.init_slug)').each(function() {

        let source = $(this);
        let parent = $('#'+source.attr('slug')+'');

        parent.on('input', function(event) {
            source.val(autocomplete_slugs(this.value));
        });
        
    }).addClass('init_slug');

    $('form.ajax:not(.init)')
        .submit(function(ev){

            ev.preventDefault();

            if($(this).hasClass('confirm')){

                let title = $(this).attr('confirm-title');
                if(typeof(title) == 'undefined'){
                    title = window.__('¿Estás seguro?');
                }

                let text = $(this).attr('confirm-text');
                if(typeof(text) == 'undefined'){
                    text = window.__('Esta acción no se puede deshacer');
                }

                messages.confirm(title, text).then(() => {
                    submit_form($(this));    
                });

            } else {
                submit_form($(this));
            }

        })
        .addClass('init');

    init_translatables();
    $("[autofocus]:visible:first").focus();

}

export function get_function(name){

    if(typeof name == 'undefined' || name == ''){
        return null;
    }

    try {
                
        let fn = '';
        eval("fn = " + name);
        if(typeof fn == 'function'){
            return fn;
        }

    } catch(e){

        try {

            let fn = eval('window.app.' + name);
            if(typeof fn == 'function'){
                return fn;
            }

        } catch(e){

            // no hay función valida

        }

    }

    return null;

}

function init_password_input(input){

    let parent = input.parent();
    let input_group_text = parent.find('.input-group-text');

    if(input_group_text.length == 0){
        
        let div = $('<div class="input-group"><div class="input-group-append"><span class="input-group-text"></span></div></div>');
        input.detach().prependTo(div);
        parent.append(div);

        input_group_text = parent.find('.input-group-text');

    }

    input_group_text
        .addClass('toggle_password')
        .html('<span class="fas fa-lock"></span>')
        .click(function(){
        
            var input = $(this).closest('.input-group').find('input');
            if(input.attr('type') == 'password'){
                
                input.attr('type', 'text');
                input.parent().find('.fas').removeClass('fa-lock').addClass('fa-unlock');

            } else {

                input.attr('type', 'password');
                input.parent().find('.fas').removeClass('fa-unlock').addClass('fa-lock');

            }

        });

    input.addClass('init');

}

function init_submit_form(input){
    
    const form = $('form#' + input.attr('form'));
    const name = input.attr('name');
    const value = input.attr('value');
    
    if(
        form.length > 0 
        && typeof(name) != 'undefined' && name != ''
        && typeof(value) != 'undefined'
    ){

        const hidden_input = form.find('input[type="hidden"][name="' + name + '"]');
        if(hidden_input.length == 0){
            $('<input type="hidden" name="' + name + '">').prependTo(form);
        }

        input.click(function(){
            $('form#' + $(this).attr('form') + ' input[type="hidden"][name="' + $(this).attr('name') + '"]').val($(this).attr('value'));
        });

    }

    input.addClass('init');

}

function submit_form(form){

    setTimeout(() => {

        // Este timeout es para evitar que los tinymce no hayan actualizado los inputs correspondientes

        const formData = new FormData(form[0]);
        const route = form.attr('action');
        const blockui = form.hasClass('blockui');
        
        post(route, formData, blockui);

    }, 100);
    
}

function autocomplete_slugs(name) {
    const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìıİłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
    const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
    const p = new RegExp(a.split('').join('|'), 'g')
  
    let slug = name.toLowerCase().replace(/\s+/g, '-') // Replace spaces with -
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w\-]+/g, '') // Remove all non-word characters
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
    
    return slug;
}


export function post(route, formData, blockui, returnPromise){

    if(typeof blockui != 'undefined' && blockui){
        window.blockui.block();
    }

    const config = {
        headers: {
            Locale: window._locale,
        }
    };

    if(typeof blockui != 'undefined' && blockui){
        window.blockui.block();
    }

    let post = axios.post(route, formData, config);

    if(typeof returnPromise != 'undefined' && returnPromise){
        return post;
    }

    post
        .then((response) => {
            try {
                parse_response(response);
            } catch {}
        })
        .catch((error) => {

            // TODO: revisar
            // if(error.response && error.response.status == 401){
            //     return redirect(window._url, true);
            // }

            if(
                typeof error.response != 'undefined'
                && typeof error.response.data != 'undefined'
                && typeof error.response.data.errors != 'undefined'
            ){
                
                for(let error_key in error.response.data.errors){
                    for(let msg of error.response.data.errors[error_key]){
                        messages.error(msg);
                    }
                }

            } else {

                if(
                    typeof error.response != 'undefined'
                    && typeof error.response.data != 'undefined'
                    && typeof error.response.data.message != 'undefined'
                ){
                    messages.error(error.response.data.message);
                } else {
                    messages.error(error.response.statusText);
                }

            }
            
        })
        .finally(() => {

            if(window.blockui.blocked){
                window.blockui.release();
            }

        });

}

function parse_response(response){

    if(
        typeof response.data.message != 'undefined'
        && typeof response.data.message_level != 'undefined'
    ){
        switch(response.data.message_level){
            
            case 'success':
                messages.success(response.data.message);
                break;
            
            case 'info':
                messages.info(response.data.message);
                break;

            case 'error':
                messages.error(response.data.message);
                break;

            case 'warning':
                messages.warning(response.data.message);
                break;

        }  
    }

    if(typeof response.data.redirect != 'undefined'){
        window.location.href = response.data.redirect;
    }

    if(typeof response.data.callback != 'undefined'){
        let callback_params = typeof response.data.callback_params != 'undefined' ? response.data.callback_params : [];
        window.callbacks.run_callback(response.data.callback, callback_params);
    }

}

function init_select2(){
    if($(this).closest('.select2-noinit').length == 0){
        
        let options = {
            dropdownParent: $(this).attr('dropdownParent') ?? $(document.body),
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        };

        if(typeof $(this).attr('ajaxSource') != 'undefined' && $(this).attr('ajaxSource') != ''){

            options.ajax = {
                url: $(this).attr('ajaxSource'),
                dataType: 'json',
            };

            let processResults = window.forms.get_function($(this).attr('processResults'));
            if(typeof processResults == 'function'){
                options.ajax.processResults = processResults;
            }

        }

        let templateResult = window.forms.get_function($(this).attr('templateResult'));
        if(typeof templateResult == 'function'){
            options.templateResult = templateResult;
        } else {
            options.templateResult = function(d){ return $('<span>' + d.text + '</span>'); };
        }

        let templateSelection = window.forms.get_function($(this).attr('templateSelection'));
        if(typeof templateSelection == 'function'){
            options.templateSelection = templateSelection;
        } else {
            options.templateSelection = function(d){ return $('<span>' + d.text + '</span>'); };
        }

        $(this)
            .css('width', '100%')
            .select2(options);
            
        $(this).addClass('init');
        
    }    
}

let editorChangeHandlerId = null;

export function init_tinymce(textarea, options){
    _init_tinymce(null, textarea, options);
}

function _init_tinymce(_, textarea, options){

    let _options = {
        language: window._locale,
        menubar: false,
        statusbar: false,
        plugins: 'autolink autoresize paste searchreplace code lists image media link table',
        paste_as_text: true,
        autoresize_bottom_margin: 30,
        relative_urls: false,
        remove_script_host: false,
        convert_urls: true,
        apply_source_formatting : false,
        verify_html : false,
    };

    if(typeof options != 'undefined'){
        for (const option in options) {
            if (options.hasOwnProperty(option)) {
                _options[option] = options[option];
            }
        }
    }

    let height = $(textarea).attr('tinymce_height');
    if(typeof height != 'undefined' && height != ''){
        if(height == 'auto'){
            _options.plugins = _options.plugins + ' autoresize';
        } else {
            _options.height = height;
        }
    }

    if($(textarea).prop('readonly')){
        _options.readonly = 1;
    } else {
        
        let toolbar = $(textarea).attr('tinymce_toolbar');
        if(typeof toolbar != 'undefined' && toolbar != ''){
            _options.toolbar = toolbar;
        }

    }

    if($(textarea).hasClass('translatable')){
        _options.setup = function(editor) {
            editor.on('Paste Change input Undo Redo', function(){
                clearTimeout(editorChangeHandlerId);
                editorChangeHandlerId = setTimeout(function() {
                    update_translations();
                }, 100);
            });
        }
    }

    $(textarea)
        .addClass('init')
        .tinymce(_options);

    $(document).on('focusin', function(e) {
        if ($(e.target).closest(".tox-tinymce, .tox-tinymce-aux, .moxman-window, .tam-assetmanager-root").length) {
            e.stopImmediatePropagation();
        }
    });

}

let selected_language = '';

function init_translatables(){

    selected_language = '';

    if($('.change_language.selected').length > 0){
        selected_language = $($('.change_language.selected')[0]).attr('language');
    } else {
        selected_language = $($('.change_language')[0]).attr('language');
    }

    $('.change_language[language="' + selected_language + '"]').addClass('selected');
    $('.change_language:not([language="' + selected_language + '"])').removeClass('selected');

    $('input[type="text"].translatable:not(.init_translatable), textarea.translatable:not(.init_translatable)').each(init_translatable);

}

function init_translatable(){

    let input = $(this);
    let component = $(this).closest('.translatable_wrapper');
    let languages = JSON.parse(component.attr('languages'));

    if(
        selected_language == ''
        || languages.indexOf(selected_language) < 0
    ){
        selected_language = languages[0];
    }
    
    switch(component.attr('translatable_type')){
        case 'input':
            component.find('input[type="text"]').change(function(){
                update_translations();
            });
        break;
        case 'textarea':
            component.find('textarea').change(function(){
                update_translations();
            });
        break;
        case 'tinymce':
            // on tinymce update -> update_translations
        break;
    }

    component.find('.change_language').click(function(){
        update_translations($(this).attr('language'));
    });

    input.addClass('init_translatable');

}

export function update_translations(to_language){

    let from_language = selected_language;

    if(typeof to_language != 'undefined'){
        selected_language = to_language;
    }

    $('.init_translatable').each(function(){

        let component = $(this).closest('.translatable_wrapper');
        component.find('.change_language[language="' + selected_language + '"]').addClass('selected');
        component.find('.change_language:not([language="' + selected_language + '"])').removeClass('selected');

        let type = component.attr('translatable_type');
        let tinymce_id = '';
        let name = '';
        let value = '';
        let is_array = false;
        
        switch(type){
            case 'input':
                name = component.find('input[type="text"]').attr('name');
                value = component.find('input[type="text"]').val();
            break;
            case 'textarea':
                name = component.find('textarea').attr('name');
                value = component.find('textarea').val();
                is_array = parseInt(component.find('input[name="__' + name + '[' + from_language + ']"]').attr('array')) == 1
                if(is_array){
                    value = value.replace(/(\r)/g, '');
                    value = value.split("\n");
                    value = JSON.stringify(value)
                }
            break;
            case 'tinymce':
                name = component.find('textarea').attr('name');
                tinymce_id = component.find('textarea').attr('id');
                value = tinymce.get(tinymce_id).getContent();
            break;
        }

        component.find('input[name="__' + name + '[' + from_language + ']"]').val(value);

        if(from_language != selected_language){

            let translation = component.find('input[name="__' + name + '[' + selected_language + ']"]').val();
            switch(type){
                case 'input':
                    component.find('input[name="' + name + '"]').val(translation);
                break;
                case 'textarea':
                    if(
                        translation != ''
                        && is_array
                    ){
                        try {
                            let _translation = JSON.parse(translation);
                            if(typeof _translation == 'object'){
                                _translation = _translation.join("\n");
                            }
                            translation = _translation;
                        } catch(ex){}
                    }
                    component.find('textarea[name="' + name + '"]').val(translation);
                break;
                case 'tinymce':
                    tinymce.get(tinymce_id).setContent(translation);
                break;
            }

        }

    });

}